import {createSelector} from 'reselect';
import {getListingSummary} from './listingSummary';
import {getFirstPayment, getPriceLabels, getTotals, getPriceDetails} from './priceDetails';
import {getSiteName, getHavId, getIsMobile, getLocale} from './system';
import {
    isDatePickerModalOpen,
    isGuestSelectorModalOpen,
    isReportListingModalOpen,
    isRequestToBookModalOpen,
    isInquiryModalOpen
} from './modalStates';
import {getBookingType, getTakesInquiries, getHostType, getUnitApiURL} from './listing';
import {getTripDataDates} from './tripDates';
import {getReviewRating} from './reviews';

const getViewDetailsTotalData = createSelector(
    [getPriceDetails, getPriceLabels, getTotals, getTripDataDates],
    (priceDetails, labels, totals, dates) => ({
        edapPriceQuotePresented: priceDetails.edapPriceQuotePresented,
        labels,
        showViewDetailsLink: !!(totals || {}).totalWithoutDeposits,
        totals,
        datesAreSet: Boolean(dates && dates.arriveDateText && dates.departDateText)
    })
);

const getRightRailData = createSelector(
    [
        getBookingType,
        getIsMobile,
        getListingSummary,
        getViewDetailsTotalData,
        getSiteName,
        isDatePickerModalOpen,
        isGuestSelectorModalOpen,
        isRequestToBookModalOpen,
        isInquiryModalOpen,
        isReportListingModalOpen,
        getTakesInquiries,
        getFirstPayment,
        getPriceDetails,
        getReviewRating,
        getHavId,
        getLocale,
        getHostType,
        getUnitApiURL
    ],
    (
        bookingType,
        isMobile,
        listingSummary,
        viewDetailsTotalData,
        siteName,
        datePickerPopoverOpen,
        guestSelectorPopoverOpen,
        requestToBookModalOpen,
        inquiryModalOpen,
        reportListingModalOpen,
        takesInquiries,
        firstPaymentData,
        priceDetails,
        {reviewCount, webRatingBadges},
        havId,
        locale,
        hostType,
        unitApiUrl
    ) => {
        return {
            listingSummaryData: listingSummary,
            viewDetailsTotalData,
            siteName,
            datePickerPopoverOpen,
            guestSelectorPopoverOpen,
            requestToBookModalOpen,
            inquiryModalOpen,
            isMobile,
            reportListingModalOpen,
            showSecondaryAction: bookingType.onlineBookable && takesInquiries,
            firstPaymentData,
            currencyConversionLabel: priceDetails.currencyConversionLabel,
            reviewCount,
            webRatingBadges,
            havId,
            locale,
            hostType,
            unitApiUrl
        };
    }
);

export default getRightRailData;
export {getRightRailData, getViewDetailsTotalData};
